import { Skeleton } from 'antd';
import type { ReactNode } from 'react';

interface StatCardProps {
  title: string;
  value: number | string;
  prefix?: ReactNode;
  suffix?: string;
  accentColor?: string;
  loading?: boolean;
}

export function StatCard({
  title,
  value,
  prefix,
  suffix,
  accentColor = 'var(--color-primary)',
  loading = false,
}: StatCardProps) {
  return (
    <div
      style={{
        background: 'var(--color-card-bg)',
        border: '1px solid var(--color-border)',
        borderTop: `2px solid ${accentColor}`,
        borderRadius: 4,
        padding: '12px 14px',
        minHeight: 84,
      }}
    >
      <div
        style={{
          fontSize: 10,
          fontWeight: 600,
          color: 'var(--color-text-muted)',
          textTransform: 'uppercase',
          letterSpacing: 0.7,
          lineHeight: 1.2,
        }}
      >
        {title}
      </div>
      <div style={{ marginTop: 6, display: 'flex', alignItems: 'baseline', gap: 4 }}>
        {loading ? (
          <Skeleton.Button active size="small" style={{ width: 140, height: 22 }} />
        ) : (
          <>
            {prefix && <span style={{ color: 'var(--color-text-secondary)' }}>{prefix}</span>}
            <span
              className="tabular"
              style={{
                fontSize: 22,
                fontWeight: 700,
                color: 'var(--color-text-primary)',
                lineHeight: 1.1,
                letterSpacing: '-0.01em',
              }}
            >
              {value}
            </span>
            {suffix && <span style={{ color: 'var(--color-text-muted)', fontSize: 12 }}>{suffix}</span>}
          </>
        )}
      </div>
    </div>
  );
}
